import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useFetch } from 'common.ui';
import Page from 'components/page/Page';
import SecurityGroupMappingForm from 'components/entra/SecurityGroupMappingForm';
import { entraClient, permissionsClient } from 'api/AdgangClients';
import RoutePaths from 'RoutePaths';

interface IParams {
  id: string;
}

function PermissionSecurityGroup() {
  const { id } = useParams<IParams>();
  const history = useHistory();
  const permissionId = +id;

  const [permission] = useFetch(async () => permissionsClient.getPermissionbyId({ id: permissionId }), undefined, false, [id]);

  return (
    <Page header='Entra-sikkerhetsgruppe' title={['Tilgang', permission?.name || '']}>
      <SecurityGroupMappingForm
        key={id}
        entityId={id}
        entityLabel='tilgangen'
        holdersText='har tilgangen direkte eller via en rolle'
        entityName={permission?.name}
        fetchMapping={() => entraClient.apiEntraPermissionsPermissionIdSecurityGroupGet({ permissionId })}
        saveMapping={(securityGroupId) =>
          entraClient.apiEntraPermissionsPermissionIdSecurityGroupPut({
            permissionId,
            setPermissionSecurityGroupRequest: { securityGroupId }
          })
        }
        syncMembers={() => entraClient.apiEntraPermissionsPermissionIdSyncPost({ permissionId })}
        onBack={() => history.push(RoutePaths.permissionsDetail.replace(':id', id))}
      />
    </Page>
  );
}

export default PermissionSecurityGroup;
